export default "__VITE_ASSET__C6Ry$R7e__"